var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.31,
    viewBox: "0 0 18 12.31"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.85 -7.909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,1H0V-1H18Z",
    transform: "translate(4.85 8.909)",
    fill: "#9e9fa4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.062,1H0V-1H11.062Z",
    transform: "translate(8.54 13.909)",
    fill: "#9e9fa4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.637,1H0V-1H6.637Z",
    transform: "translate(10.31 19.219)",
    fill: "#9e9fa4"
  }))));
};
export default SvgFilterIcon;